export function parseAPIData(data) {
  const keys = Object.keys(data);
  const entries = keys.map((key) => {
    const val = data[key];
    let newVal = val;
    if (typeof val === 'object') {
      if (val === null) {
        newVal = [];
      }
      if (val?.hasOwnProperty('String')) {
        newVal = val.String;
      }
    }
    return [key, newVal];
  });

  return Object.fromEntries(entries);
}

export function renderArrayStr(data, direction = 'column') {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: `${direction}`,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '0 6px'
      }}
    >
      {data.map((str, idx) => (
        <div
          key={idx}
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            minHeight: '20px',
            width: 'auto'
          }}
        >
          {str && <p style={{ marginRight: '3px' }}>{`${str},`}</p>}
        </div>
      ))}
    </div>
  );
}
